import { Loader2 } from 'lucide-react';

/**
 * Suspense fallback shown while a lazily-loaded route chunk downloads
 * (audit PERF-2). Deliberately minimal — a centered spinner inside the
 * existing content area, so layout chrome (sidebar/topbar) stays put.
 */
export function RouteFallback(): JSX.Element {
  return (
    <div className="grid h-full place-items-center py-20 text-ink-muted">
      <Loader2 className="size-5 animate-spin" aria-label="Loading" />
    </div>
  );
}
